export const PENDING_APPROVAL_ADVISER_EDUCATION_ADD_NEW_QUALIFICATION = 'PENDING_APPROVAL_ADVISER_EDUCATION_ADD_NEW_QUALIFICATION'
export const PENDING_APPROVAL_ADVISER_EDUCATION_START_EDITING = 'PENDING_APPROVAL_ADVISER_EDUCATION_START_EDITING'
export const PENDING_APPROVAL_ADVISER_EDUCATION_STOP_EDITING = 'PENDING_APPROVAL_ADVISER_EDUCATION_STOP_EDITING'
export const PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_EDITING = 'PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_EDITING'
export const PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION = 'PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION'
export const PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_MONTH = 'PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_MONTH'
export const PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_YEAR = 'PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_YEAR'
export const PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_MONTH = 'PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_MONTH'
export const PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_YEAR = 'PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_YEAR'
export const PENDING_APPROVAL_ADVISER_EDUCATION_SET_STUDY_END_DATE_CURRENT = 'PENDING_APPROVAL_ADVISER_EDUCATION_SET_STUDY_END_DATE_CURRENT'
export const PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION = 'PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION'
export const PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION_MODAL = 'PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION_MODAL'
export const PENDING_APPROVAL_ADVISER_EDUCATION_DELETING_QUALIFICATION = 'PENDING_APPROVAL_ADVISER_EDUCATION_DELETING_QUALIFICATION'
export const PENDING_APPROVAL_ADVISER_EDUCATION_DELETED_QUALIFICATION = 'PENDING_APPROVAL_ADVISER_EDUCATION_DELETED_QUALIFICATION'
export const PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_DELETING_QUALIFICATION = 'PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_DELETING_QUALIFICATION'
import { modificationStates } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'

export const setAddNewQualification = () => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_ADD_NEW_QUALIFICATION,
  qualification: {
    description: null,
    institution: null,
    studyEndDate: new Date().toISOString(),
    studyStartDate: new Date().toISOString(),
    modificationState: modificationStates.added
  }
})

export const setStartEditingQualification = (index) => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_START_EDITING,
  index
})

export const setStopEditingQualification = () => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_STOP_EDITING
})

export const setCancelEditingQualification = () => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_EDITING
})

export const setQualification = (validationResult, qualification) => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION,
  qualification,
  validationResult
})

export const setQualificationStudyStartMonth = (validationResult, month) => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_MONTH,
  month,
  validationResult
})

export const setQualificationStudyStartYear = (validationResult, year) => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_YEAR,
  validationResult,
  year
})

export const setQualificationStudyEndMonth = (validationResult, month) => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_MONTH,
  month,
  validationResult
})

export const setQualificationStudyEndYear = (validationResult, year) => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_YEAR,
  validationResult,
  year
})

export const setQualificationStudyEndDateCurrent = () => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_SET_STUDY_END_DATE_CURRENT
})

export const setDeleteQualificationModal = (index) => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION_MODAL,
  index
})

const setDeleteQualification = () => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION
})

export const setDeletingQualification = () => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_DELETING_QUALIFICATION
})

export const setDeletedQualification = () => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_DELETED_QUALIFICATION
})

export const setDeletingQualificationCancel = () => ({
  type: PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_DELETING_QUALIFICATION
})

export const deleteQualification = () => {
  return (dispatch) => {
    dispatch(setDeleteQualification())
    dispatch(setDeletingQualification())
  }
}

